import { MatomoTracker } from "../matomo/MatomoTracker";
import { ITracker } from "./interfaces/ITracker";

export const tracker: ITracker = new MatomoTracker();
